import React, { SVGProps } from 'react';

export const EmptyListImage = ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width="340"
    height="200"
    viewBox="0 0 340 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M77.8091 124.922C68.5256 90.9591 88.5322 55.9011 122.495 46.6176L183.988 29.8091C217.95 20.5256 253.008 40.5322 262.292 74.4949C271.575 108.458 251.569 143.516 217.606 152.799L156.113 169.608C122.151 178.891 87.0925 158.885 77.8091 124.922Z"
      fill="#EDF3FF"
    />
    <path
      d="M132.074 46.942C133.154 45.1182 135.117 43.9998 137.236 43.9998H201.984C204.086 43.9998 206.035 45.1004 207.121 46.9008L229.598 84.1632L230 103H109L109.804 84.5399L132.074 46.942Z"
      fill="#EDF3FF"
    />
    <path
      d="M201.984 43.9998C204.086 43.9998 206.035 45.1004 207.121 46.9008L229.598 84.1632L230 103H109L109.804 84.5399L132.074 46.942C133.154 45.1182 135.117 43.9998 137.236 43.9998H201.984ZM137.236 44.9998C135.47 44.9998 133.835 45.9322 132.934 47.4519L110.791 84.8338L110.045 102H228.978L228.603 84.45L206.266 47.4168C205.361 45.9166 203.735 44.9998 201.983 44.9998H137.236Z"
      fill="#99BCFF"
    />
    <path
      d="M205 80.9998V51.9998C205 50.8952 204.104 49.9998 203 49.9998H136C134.895 49.9998 134 50.8952 134 51.9998V80.9998C134 82.1044 134.895 82.9998 136 82.9998H203C204.104 82.9998 205 82.1044 205 80.9998Z"
      fill="#D8E5FF"
    />
    <path
      d="M204.5 51.9998C204.5 51.1714 203.828 50.4998 203 50.4998H136C135.171 50.4998 134.5 51.1714 134.5 51.9998V80.9998C134.5 81.8282 135.171 82.4998 136 82.4998H203C203.828 82.4998 204.5 81.8282 204.5 80.9998V51.9998ZM205.5 80.9998C205.5 82.3805 204.381 83.4998 203 83.4998H136C134.619 83.4998 133.5 82.3805 133.5 80.9998V51.9998C133.5 50.6191 134.619 49.4998 136 49.4998H203C204.381 49.4998 205.5 50.6191 205.5 51.9998V80.9998Z"
      fill="#99BCFF"
    />
    <path
      d="M210 90.9998V59.9998C210 58.8952 209.104 57.9998 208 57.9998H131C129.895 57.9998 129 58.8952 129 59.9998V90.9998H210Z"
      fill="#EDF3FF"
    />
    <path
      d="M209.5 59.9998C209.5 59.1714 208.828 58.4998 208 58.4998H131C130.171 58.4998 129.5 59.1714 129.5 59.9998V90.4998H209.5V59.9998ZM210.5 90.9998C210.5 91.2759 210.276 91.4998 210 91.4998H129C128.724 91.4998 128.5 91.2759 128.5 90.9998V59.9998C128.5 58.6191 129.619 57.4998 131 57.4998H208C209.381 57.4998 210.5 58.6191 210.5 59.9998V90.9998Z"
      fill="#99BCFF"
    />
    <path
      d="M216 102V69.9998C216 68.8952 215.104 67.9998 214 67.9998H125C123.895 67.9998 123 68.8952 123 69.9998V102H216Z"
      fill="white"
    />
    <path
      d="M215.5 69.9998C215.5 69.1714 214.828 68.4998 214 68.4998H125C124.171 68.4998 123.5 69.1714 123.5 69.9998V101.5H215.5V69.9998ZM216.5 102C216.5 102.276 216.276 102.5 216 102.5H123C122.724 102.5 122.5 102.276 122.5 102V69.9998C122.5 68.6191 123.619 67.4998 125 67.4998H214C215.381 67.4998 216.5 68.6191 216.5 69.9998V102Z"
      fill="#99BCFF"
    />
    <path
      d="M108 77.9998C108 76.8952 108.895 75.9998 110 75.9998H139.26C140.742 75.9998 142.102 76.8188 142.796 78.1283L148.343 88.6081C149.037 89.9176 150.397 90.7366 151.879 90.7366H187.711C189.192 90.7366 190.553 89.9176 191.246 88.6081L196.794 78.1283C197.487 76.8188 198.847 75.9998 200.329 75.9998H230C231.104 75.9998 232 76.8952 232 77.9998V138C232 142.418 228.418 146 224 146H116C111.582 146 108 142.418 108 138V77.9998Z"
      fill="#D8E5FF"
    />
    <path
      d="M224 145V146H116V145H224ZM231 138V77.9998C231 77.4475 230.552 76.9998 230 76.9998H200.329C199.218 76.9998 198.198 77.6143 197.678 78.5965L192.13 89.076C191.263 90.7128 189.563 91.7371 187.711 91.7371H151.879C150.027 91.7371 148.326 90.7127 147.46 89.076L141.912 78.5965C141.392 77.6144 140.372 76.9999 139.261 76.9998H110C109.448 76.9998 109 77.4475 109 77.9998V138C109 141.866 112.134 145 116 145V146C111.72 146 108.225 142.639 108.011 138.412L108 138V77.9998C108 76.8952 108.895 75.9998 110 75.9998H139.26L139.537 76.0096C140.91 76.1045 142.146 76.9008 142.796 78.1283L148.343 88.6081C148.993 89.8357 150.23 90.6326 151.602 90.7273L151.879 90.7366H187.711C189.1 90.7366 190.382 90.0165 191.108 88.8474L191.246 88.6081L196.794 78.1283C197.444 76.9007 198.68 76.1043 200.053 76.0096L200.329 75.9998H230C231.104 75.9998 232 76.8952 232 77.9998V138C232 142.418 228.418 146 224 146V145C227.866 145 231 141.866 231 138Z"
      fill="#99BCFF"
    />
    <path
      d="M188 138C188 147.941 179.941 156 170 156C160.059 156 152 147.941 152 138C152 128.059 160.059 120 170 120C179.941 120 188 128.059 188 138Z"
      fill="#B8CEFA"
    />
    <path
      d="M187 138C187 128.611 179.389 121 170 121C160.611 121 153 128.611 153 138C153 147.389 160.611 155 170 155V156C160.059 156 152 147.941 152 138C152 128.059 160.059 120 170 120C179.941 120 188 128.059 188 138C188 147.941 179.941 156 170 156V155C179.389 155 187 147.389 187 138Z"
      fill="white"
    />
    <path
      d="M179 137C179.552 137 180 137.448 180 138C180 138.552 179.552 139 179 139H161C160.448 139 160 138.552 160 138C160 137.448 160.448 137 161 137H179Z"
      fill="white"
    />
    <path
      d="M169 129C169 128.448 169.448 128 170 128C170.552 128 171 128.448 171 129V147C171 147.552 170.552 148 170 148C169.448 148 169 147.552 169 147V129Z"
      fill="white"
    />
    <path
      d="M228 90.9998V88.9998C228 87.8952 227.104 86.9998 226 86.9998H206C204.895 86.9998 204 87.8952 204 88.9998V90.9998C204 92.1044 204.895 92.9998 206 92.9998L226 92.9998C227.104 92.9998 228 92.1044 228 90.9998Z"
      fill="#B8CEFA"
    />
    <path
      d="M228 99.9998V97.9998C228 96.8952 227.104 95.9998 226 95.9998H198C196.895 95.9998 196 96.8952 196 97.9998V99.9998C196 101.104 196.895 102 198 102L226 102C227.104 102 228 101.104 228 99.9998Z"
      fill="#B8CEFA"
    />
  </svg>
);
